import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up


import { InsuranceCompanyModel } from 'src/app/models/InsuranceCompanyModel';
import { IsuranceCopmanyService } from 'src/app/services/IsuranceCopmanyService';

@Component({
  selector: 'app-isurance-copmany-search',
  templateUrl: './isurance-copmany-search.component.html',
  styleUrls: ['./isurance-copmany-search.component.css']
})
export class IsuranceCopmanySearchComponent implements OnInit {
insid = 0 ;
insenglishname = '' ;
insarabicname = '' ;
insaddress = '' ;
insphone1 = '' ;
insphone2 = '' ;
insemail = '' ;
inscontatpersonname = '' ;
inscontatpersontitle = '' ;
inscontatpersonmobile = '' ;
inscontatpersonemail = '' ;
insapprovalsemail = '' ;

inslogo = '' ;
userid = '' ;

compcode = '' ;

CompamyList : InsuranceCompanyModel[]=[];
@Output() submitClicked = new EventEmitter<any>();
  constructor(
     public dialogRef: MatDialogRef<IsuranceCopmanySearchComponent>,
    public insurancecopmanyserive : IsuranceCopmanyService,
     public storage: LocalStorageService,
      @Inject(MAT_DIALOG_DATA)
      public itemsSelectedData : InsuranceCompanyModel,
             
  ) { }

  ngOnInit(): void {
    this.retriveCompanies();
  }
  retriveCompanies() {
      this.CompamyList = [];
        this.insurancecopmanyserive.getIsuranceCopmanyLookupTop().subscribe((data: InsuranceCompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.CompamyList[i] = data[i];
        }
      })
    }
SelectItem(item: InsuranceCompanyModel){
    this.itemsSelectedData.insid = item.insid
    this.submitClicked.emit(this.itemsSelectedData);
    this.dialogRef.close();
  
  }
}
